import React from 'react';
import ButtonDropdown from 'ui/modules/ButtonDropdown';
import Checkbox from 'ui/elements/form/choice/Checkbox';
import { ShortlistedCompaniesOrder } from 'apis/CompanyAPI/users/usersApi';

const orderLabels: Record<ShortlistedCompaniesOrder, string> = {
  'latest-activity': 'Latest activity',
  'recently-added': 'Recently added',
  name: 'Name',
};

export interface CompaniesFilterValues {
  orderBy: ShortlistedCompaniesOrder;
  raising: boolean;
}

interface Props {
  values: CompaniesFilterValues;
  onChange: (values: CompaniesFilterValues) => void;
}

export default function CompaniesFilters({ values, onChange }: Props) {
  return (
    <div className="u-flex u-flex-align-center u-flex--gap-half">
      <Checkbox
        label="Raising now"
        fontSize="small"
        checked={values.raising}
        onChange={e => onChange({ ...values, raising: e.target.checked })}
      />
      <ButtonDropdown
        color="white"
        items={(Object.keys(orderLabels) as ShortlistedCompaniesOrder[]).map(orderBy => ({
          text: orderLabels[orderBy],
          checked: values.orderBy === orderBy,
          rightIcon: 'radio',
          onClick: () => onChange({ ...values, orderBy }),
        }))}
      >
        <span className="text-metadata">Sort:</span> {orderLabels[values.orderBy]}
      </ButtonDropdown>
    </div>
  );
}
